import React, { useState } from "react";
import { Add } from "@mui/icons-material";
import { Box } from "@mui/material";

import { AddEditClient, ClientList, ClientOverview } from "../../components/client";
import { PageHeader } from "../../components/v3";
import { CREATE_CLIENT, VIEW_CLIENT_ANALYTICS } from "../../constants";
import { PageLayout } from "../../layouts/PageLayout";
import { useHasPermission } from "../../utils";

export const Clients = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const hadCreateClient = useHasPermission(CREATE_CLIENT);
  const hasViewAnalytics = useHasPermission(VIEW_CLIENT_ANALYTICS);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hadCreateClient && {
      buttonText: "Add Client",
      buttonIcon: Add,
      onClick: handleOpenModal,
    },
  ];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <PageHeader
          // title
          title="Clients"
          subtitle={`${totalCount} Clients`}
          // button
          buttons={buttons}
        />

        {hasViewAnalytics ? (
          <>
            <Box sx={{ position: "relative", height: 40 }}>
              <ClientOverview />
            </Box>
            <ClientList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
          </>
        ) : (
          <Box sx={{ mt: -9, position: "relative", zIndex: 2 }}>
            <ClientList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
          </Box>
        )}
      </PageLayout>
      {/* add client modal */}
      <AddEditClient open={openModal} onClose={handleCloseModal} onSuccess={handleReload} />
    </>
  );
};
